import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
    solicitacoes: []
};

const equipamentosSlice = createSlice({
    name: "equipamentos",
    initialState, 
    reducers: {
        adicionarEquipamento: (state, action) => {
            let novoEquipamento = action.payload[0];

            let solicitacaoJaAdcionada =
                state.solicitacoes.findIndex(
                    (solic) => solic.CodigoSolicitacaoAcesso == novoEquipamento.CodigoSolicitacaoAcesso
                );

            if (solicitacaoJaAdcionada == -1) {
                let novaSolicitacao = {
                    CodigoSolicitacaoAcesso: 0,
                    Equipamentos: []
                };

                novaSolicitacao.CodigoSolicitacaoAcesso = novoEquipamento.CodigoSolicitacaoAcesso;
                novaSolicitacao.Equipamentos = novoEquipamento;

                state.solicitacoes.push(novaSolicitacao)
            } else {
                state.solicitacoes = state.solicitacoes.map((solic) => {
                    if (solic.CodigoSolicitacaoAcesso == novoEquipamento.CodigoSolicitacaoAcesso) {
                        solic.Equipamentos.push(novoEquipamento);
                    }
                })
            }

            return state;
        },
        adicionarSolicitacaoEquip: (state, action) => {
            let inputSolic = action.payload[0];
    
            let solicitacaoJaAdcionada = 
                state.solicitacoes.findIndex(
                    (solic) => solic?.CodigoSolicitacaoAcesso == inputSolic.CodigoSolicitacaoAcesso
                );
    
            let novaSolicitacao = {
                CodigoSolicitacaoAcesso: 0,
                Equipamentos: []
            };

            if (solicitacaoJaAdcionada == -1) {
                novaSolicitacao.CodigoSolicitacaoAcesso = inputSolic.CodigoSolicitacaoAcesso;

                if (typeof inputSolic === 'object' ) {
                    novaSolicitacao.Equipamentos = inputSolic;
                } else {
                    inputSolic.forEach(equipamento => {
                        novaSolicitacao.Equipamentos.push(equipamento);
                    });
                }

                state.solicitacoes.push(novaSolicitacao);
            } else {
                state.solicitacoes =state.solicitacoes.map((solict, index) => {
                    if (index == solicitacaoJaAdcionada) {
                        solict.Equipamentos = action.payload;
                    }

                    return solict;
                })
            }

            return state;
        },
        removerEquipamento: (state, action) => {
            state.solicitacoes = state.solicitacoes.map((solict) => {
                if (solict.CodigoSolicitacaoAcesso == action.payload.CodigoSolicitacaoAcesso) {
                    solict.Equipamentos = solict.Equipamentos.filter((equipamento) => equipamento.Id != action.payload.Id)
                }

                return solict;
            });

            return state;
        }
    }
});

export const { adicionarEquipamento, adicionarSolicitacaoEquip, removerEquipamento } = equipamentosSlice.actions;
export default equipamentosSlice.reducer;